// extracted by mini-css-extract-plugin
export default {"card":"card_card__7WVYK","info":"card_info__wHIMY","title":"card_title__Si1MX"};